<template>
  <div>
    <hr />
    <nav>
      <div class="nav nav-tabs" id="nav-tab" role="tablist">
        <a
          @click="handleStep('LANCAMENTO')"
          :class="[
            'nav-link link-nav-resident',
            step == 'LANCAMENTO' && 'active',
          ]"
          id="nav-launch"
          data-toggle="tab"
          href="#launch"
          role="tab"
          aria-controls="launch"
          aria-selected="true"
          >LANÇAMENTOS</a
        >
        <a
          @click="handleStep('FATURAMENTO')"
          :class="[
            'nav-link link-nav-resident',
            step == 'FATURAMENTO' && 'active',
          ]"
          id="nav-invoicing"
          data-toggle="tab"
          href="#invoicing"
          role="tab"
          aria-controls="invoicing"
          aria-selected="true"
          >FATURAMENTOS PENDENTES</a
        >
        <a
          @click="handleStep('FATURADO')"
          :class="[
            'nav-link link-nav-resident',
            step == 'FATURADO' && 'active',
          ]"
          id="nav-billed"
          data-toggle="tab"
          href="#billed"
          role="tab"
          aria-controls="billed"
          aria-selected="true"
          >PENDENTES NO FINANCEIRO</a
        >
        <a
          @click="handleStep('AGUARDANDO_PAGAMENTO')"
          :class="[
            'nav-link link-nav-resident',
            step == 'AGUARDANDO_PAGAMENTO' && 'active',
          ]"
          id="nav-awaiting-payment"
          data-toggle="tab"
          href="#awaiting-payment"
          role="tab"
          aria-controls="awaiting-payment"
          aria-selected="true"
          >AGUARDANDO PAGAMENTO</a
        >
        <a
          @click="handleStep('ATRASADO')"
          :class="[
            'nav-link link-nav-resident',
            step == 'ATRASADO' && 'active',
          ]"
          id="nav-late"
          data-toggle="tab"
          href="#late"
          role="tab"
          aria-controls="late"
          aria-selected="true"
          >ATRASADO</a
        >
        <a
          @click="handleStep('PAGO')"
          :class="['nav-link link-nav-resident', step == 'PAGO' && 'active']"
          id="nav-paid-out"
          data-toggle="tab"
          href="#paid-out"
          role="tab"
          aria-controls="paid-out"
          aria-selected="true"
          >PAGO</a
        >
      </div>
    </nav>
    <div class="tab-content" id="nav-tabContent">
      <div
        v-if="step == 'LANCAMENTO'"
        :class="['tab-pane fade', step == 'LANCAMENTO' && 'show active']"
        id="launch"
        role="tabpanel"
        aria-labelledby="nav-launch"
      >
        <launch :resident_id="resident_id" />
      </div>
      <div
        v-if="step == 'FATURAMENTO'"
        :class="['tab-pane fade', step == 'FATURAMENTO' && 'show active']"
        id="invoicing"
        role="tabpanel"
        aria-labelledby="nav-invoicing"
      >
        <invoicing :resident_id="resident_id" />
      </div>
      <div
        v-if="step == 'FATURADO'"
        :class="['tab-pane fade', step == 'FATURADO' && 'show active']"
        id="billed"
        role="tabpanel"
        aria-labelledby="nav-billed"
      >
        <billed :resident_id="resident_id" />
      </div>
      <div
        v-if="step == 'AGUARDANDO_PAGAMENTO'"
        :class="[
          'tab-pane fade',
          step == 'AGUARDANDO_PAGAMENTO' && 'show active',
        ]"
        id="awaiting-payment"
        role="tabpanel"
        aria-labelledby="nav-awaiting-payment"
      >
        <awaiting-payment :resident_id="resident_id" />
      </div>
      <div
        v-if="step == 'ATRASADO'"
        :class="['tab-pane fade', step == 'ATRASADO' && 'show active']"
        id="late"
        role="tabpanel"
        aria-labelledby="nav-late"
      >
        <late :resident_id="resident_id" />
      </div>
      <div
        v-if="step == 'PAGO'"
        :class="['tab-pane fade', step == 'PAGO' && 'show active']"
        id="paid-out"
        role="tabpanel"
        aria-labelledby="nav-paid-out"
      >
        <paid-out :resident_id="resident_id" />
      </div>
    </div>
  </div>
</template>

<script>
import Launch from "./HostingFinance/launch.vue";
import Invoicing from "./HostingFinance/invoicing.vue";
import Billed from "./HostingFinance/billed";
import AwaitingPayment from "./HostingFinance/awaiting-payment";
import Late from "./HostingFinance/late";
import PaidOut from "./HostingFinance/paid-out";

import routes from "../../routes";

export default {
  name: "MenuHostingFinancial",

  components: {
    Launch,
    Invoicing,
    Billed,
    AwaitingPayment,
    Late,
    PaidOut,
  },

  props: {
    resident: Object,
  },

  data() {
    return {
      step: "LANCAMENTO",

      resident_id: "",
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    handleStep(step) {
      let newMenu;

      if (step == "LANCAMENTO") {
        newMenu = "launch";
      } else if (step == "FATURAMENTO") {
        newMenu = "invoicing";
      } else if (step == "FATURADO") {
        newMenu = "billed";
      } else if (step == "AGUARDANDO_PAGAMENTO") {
        newMenu = "awaiting_payment";
      } else if (step == "ATRASADO") {
        newMenu = "late";
      } else if (step == "PAGO") {
        newMenu = "paid_out";
      }

      let { tab, nav, menu } = routes.history.current.query;

      if (menu != newMenu) {
        routes.replace({ query: { tab, nav, menu: newMenu } });
      }

      this.step = step;
    },

    async retrieve() {
      const { menu } = routes.history.current.query;

      const { id } = routes.history.current.params;

      this.resident_id = id;

      if (menu) {
        if (menu == "launch") {
          this.step = "LANCAMENTO";
        } else if (menu == "invoicing") {
          this.step = "FATURAMENTO";
        } else if (menu == "billed") {
          this.step = "FATURADO";
        } else if (menu == "awaiting_payment") {
          this.step = "AGUARDANDO_PAGAMENTO";
        } else if (menu == "late") {
          this.step = "ATRASADO";
        } else if (menu == "paid_out") {
          this.step = "PAGO";
        } else {
          this.step = "LANCAMENTO";
        }
      } else {
        this.step = "LANCAMENTO";
      }
    },
  },
};
</script>